(() => {
    const modal = document.getElementById('search-modal');
    if (!modal || modal.dataset.phsBound === 'true') return;
    modal.dataset.phsBound = 'true';

    const ROOT = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root.replace(/\/$/, '') : '';
    /* Se busca desde la PRIMERA letra. Antes era 2, y con 2 el motor descartaba
       las palabras de 1-2 letras, así que se entraba en la pantalla de
       resultados para enseñar "sin resultados" y luego a la tercera letra
       aparecía todo. Ahora el motor puntúa las cortas por principio de palabra
       y con una letra ya devuelve algo con sentido. */
    const MINIMO = 1;
    const POR_TANDA = 24;
    const MAX_SUGERENCIAS = 6;

    const dlg = modal.querySelector('dialog');
    const form = modal.querySelector('[data-phs-form]');
    const input = modal.querySelector('[data-phs-input]');
    const limpiar = modal.querySelector('[data-phs-clear]');
    const chipsBox = modal.querySelector('[data-phs-chips]');
    const vacio = modal.querySelector('[data-phs-empty]');
    const recoGrid = modal.querySelector('[data-phs-reco]');
    const resultados = modal.querySelector('[data-phs-results]');
    const grid = modal.querySelector('[data-phs-grid]');
    const cuenta = modal.querySelector('[data-phs-count]');
    const btnMas = modal.querySelector('[data-phs-more]');
    const cargandoEl = modal.querySelector('[data-phs-loading]');
    const cero = modal.querySelector('[data-phs-zero]');
    const pie = modal.querySelector('[data-phs-foot]');
    const sugBox = modal.querySelector('[data-phs-sug]');
    if (!dlg || !input || !grid) return;

    const PH = () => window.PHSearch;
    if (PH()) PH().setRoot(ROOT);

    /* ---- Estado ---- */
    const estado = { items: [], mostrados: 0, bruto: '', sel: { marca: null, nivel: null, juego: null, forma: null } };
    let recoPintado = false;
    let precargado = false;

    /* ---- Aviso transitorio DENTRO del dialog (los toasts de body quedan
       debajo del top-layer y no se ven con el buscador abierto). ---- */
    let avisoTimer;
    const avisoDialog = (texto) => {
      let el = dlg.querySelector('[data-phs-aviso]');
      if (!el) {
        el = document.createElement('div');
        el.className = 'phs__aviso';
        el.setAttribute('data-phs-aviso', '');
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        dlg.appendChild(el);
      }
      el.textContent = texto;
      el.classList.add('is-on');
      clearTimeout(avisoTimer);
      avisoTimer = setTimeout(() => el.classList.remove('is-on'), 2600);
    };

    /* ---- Integración favoritos + comparador en tarjetas ---- */
    const SVG_CORAZON = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" focusable="false" aria-hidden="true"><path class="phs-fill" d="M12 20.5l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 4.42 4.42 2 7.5 2c1.74 0 3.41.81 4.5 2.09C13.09 2.81 14.76 2 16.5 2 19.58 2 22 4.42 22 7.5c0 3.78-3.4 6.86-8.55 11.68L12 20.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
    const SVG_COMPARAR = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" focusable="false" aria-hidden="true"><rect x="3" y="4" width="7" height="16" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="4" width="7" height="16" rx="1.5" stroke="currentColor" stroke-width="1.6"/></svg>';

    const entradaDe = (p) => ({
      handle: p.h,
      title: p.t,
      url: `${ROOT}/products/${p.h}`,
      image: PH().imgUrl(p.i, 200) || '',
      price: PH().formatEuro(p.p),
      vendor: p.v || ''
    });

    const esPala = (p) => PH().sinTildes(p.y || '') === 'palas de padel';

    /* ---- Insignias (espejo del snippet Liquid 'ph-badges') ----
       Mismas reglas y mismo orden de prioridad que las tarjetas del tema, para
       que una pala se vea igual en el buscador que en una coleccion.
       Unica diferencia: NO hay "Ultimas unidades", porque products.json (de
       donde sale el catalogo del buscador) no expone el inventario. */
    const MAX_INSIGNIAS = 2;

    const insignias = (p) => {
      if (!p.a) return [['agotado', 'Agotado']];

      const out = [];
      const precio = parseFloat(p.p);
      const antes = parseFloat(p.c);
      if (antes > precio) {
        out.push(['descuento', '−' + Math.round((antes - precio) / antes * 100) + '%']);
      }

      const tags = p.g || [];
      if (tags.includes('Edición limitada')) out.push(['limitada', 'Edición limitada']);
      if (tags.includes('Nuevo')) out.push(['nuevo', 'Nuevo']);
      if (tags.includes('Más vendido')) out.push(['top', 'Más vendido']);

      return out.slice(0, MAX_INSIGNIAS);
    };

    const pilaInsignias = (p) => {
      const lista = insignias(p);
      if (!lista.length) return null;
      const pila = document.createElement('span');
      pila.className = 'phs-card__badges ph-badges';
      lista.forEach(([clase, texto]) => {
        const b = document.createElement('span');
        b.className = 'ph-badge ph-badge--' + clase;
        b.textContent = texto;
        pila.appendChild(b);
      });
      return pila;
    };

    /* Repinta el estado (activo/inactivo) de todos los iconos del modal. */
    const pintaEstados = () => {
      if (window.PHWishlist) {
        modal.querySelectorAll('[data-phs-wish]').forEach((b) => {
          const on = window.PHWishlist.has(b.dataset.phsWish);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', String(on));
        });
      }
      if (window.PHComparar) {
        modal.querySelectorAll('[data-phs-comp]').forEach((b) => {
          const on = window.PHComparar.has(b.dataset.phsComp);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', String(on));
        });
      }
    };

    /* Contador vivo en el CTA "Comparar palas (n)" de la cabecera. */
    const ctaCompararLabel = modal.querySelector('[data-phs-compare-label]');
    const pintaCompararCta = () => {
      if (!ctaCompararLabel || !window.PHComparar) return;
      const n = window.PHComparar.items().length;
      ctaCompararLabel.textContent = n > 0 ? `Comparar palas (${n})` : 'Comparar palas';
    };

    document.addEventListener('ph:comparar:change', () => { pintaEstados(); pintaCompararCta(); });
    document.addEventListener('ph:wishlist:change', pintaEstados);

    /* ---- Tarjeta de producto (jerarquía de "Palas destacadas") ---- */
    const tarjeta = (p) => {
      const ph = PH();
      const card = document.createElement('div');
      card.className = 'phs-card' + (p.a ? '' : ' phs-card--out');

      const a = document.createElement('a');
      a.className = 'phs-card__link';
      a.href = `${ROOT}/products/${p.h}`;
      const media = document.createElement('span');
      media.className = 'phs-card__media';
      if (p.i) {
        const im = document.createElement('img');
        im.src = ph.imgUrl(p.i, 360);
        im.alt = p.t;
        im.loading = 'lazy';
        media.appendChild(im);
      }
      const pila = pilaInsignias(p);
      if (pila) media.appendChild(pila);
      a.appendChild(media);
      if (p.v) {
        const ve = document.createElement('span');
        ve.className = 'phs-card__vendor';
        ve.textContent = p.v;
        a.appendChild(ve);
      }
      const ti = document.createElement('span');
      ti.className = 'phs-card__title';
      ti.textContent = p.t;
      a.appendChild(ti);
      const pr = document.createElement('span');
      pr.className = 'phs-card__price';
      if (p.a) {
        pr.textContent = ph.formatEuro(p.p);
        if (p.c && parseFloat(p.c) > parseFloat(p.p)) {
          const s = document.createElement('s');
          s.textContent = ph.formatEuro(p.c);
          pr.appendChild(s);
        }
      } else {
        pr.textContent = 'Agotado';
        pr.classList.add('phs-card__price--out');
      }
      a.appendChild(pr);
      card.appendChild(a);

      /* Iconos de acción fuera del enlace (un botón dentro de un <a> es
         inválido y dispararía la navegación). */
      const acts = document.createElement('div');
      acts.className = 'phs-card__acts';
      if (window.PHWishlist) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'phs-card__act' + (window.PHWishlist.has(p.h) ? ' is-on' : '');
        b.dataset.phsWish = p.h;
        b.setAttribute('aria-label', 'Guardar ' + p.t + ' en favoritos');
        b.setAttribute('aria-pressed', String(window.PHWishlist.has(p.h)));
        b.innerHTML = SVG_CORAZON;
        b.addEventListener('click', () => {
          const added = window.PHWishlist.toggle(entradaDe(p));
          avisoDialog(added ? 'Guardada en favoritos.' : 'Quitada de favoritos.');
        });
        acts.appendChild(b);
      }
      if (window.PHComparar && esPala(p)) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'phs-card__act' + (window.PHComparar.has(p.h) ? ' is-on' : '');
        b.dataset.phsComp = p.h;
        b.setAttribute('aria-label', 'Añadir ' + p.t + ' al comparador');
        b.setAttribute('aria-pressed', String(window.PHComparar.has(p.h)));
        b.innerHTML = SVG_COMPARAR;
        b.addEventListener('click', () => {
          const r = window.PHComparar.toggle(entradaDe(p));
          if (r.full) {
            avisoDialog('Solo puedes comparar 3 palas. Quita una para añadir otra.');
            return;
          }
          avisoDialog(r.added ? 'Añadida al comparador.' : 'Quitada del comparador.');
        });
        acts.appendChild(b);
      }
      if (acts.children.length) card.appendChild(acts);

      /* Captación en agotados: "Avísame cuando vuelva" (tag ph-aviso-stock). */
      if (!p.a && window.PHCapture) {
        const btnAv = document.createElement('button');
        btnAv.type = 'button';
        btnAv.className = 'phs-card__avisame';
        btnAv.textContent = 'Avísame cuando vuelva';
        const form = document.createElement('div');
        form.className = 'phs-card__avisoform';
        form.hidden = true;
        form.innerHTML =
          '<input type="email" class="phs-card__avisoinput" placeholder="tu@email.com" autocomplete="email">' +
          '<label class="phs-card__avisoconsent"><input type="checkbox"><span>Acepto recibir el aviso y novedades por email.</span></label>' +
          '<button type="button" class="phs-card__avisosend">Avisadme</button>' +
          '<p class="phs-card__avisomsg" hidden></p>';
        btnAv.addEventListener('click', () => { form.hidden = !form.hidden; });
        const msg = form.querySelector('.phs-card__avisomsg');
        const aviso = (t, err) => { msg.textContent = t; msg.classList.toggle('is-error', !!err); msg.hidden = false; };
        form.querySelector('.phs-card__avisosend').addEventListener('click', () => {
          aviso('Enviando…');
          window.PHCapture.enviar({
            email: form.querySelector('input[type="email"]').value,
            consent: form.querySelector('input[type="checkbox"]').checked,
            tipo: 'aviso-stock',
            cuerpo: 'Producto agotado: ' + p.t + ' (' + p.v + ')\n' + location.origin + ROOT + '/products/' + p.h
          }).then(() => {
            aviso('Hecho. Te avisamos cuando vuelva.');
          }).catch((e) => {
            if (e && e.message === 'email') return aviso('Escribe un email válido.', true);
            if (e && e.message === 'consent') return aviso('Marca la casilla para poder avisarte.', true);
            if (e && /^alta-/.test(e.message)) return aviso('Hecho. Te avisamos cuando vuelva.');
            console.error('[PHS] no se ha podido enviar el aviso de stock:', (e && e.message) || e);
            aviso('No se pudo enviar. Inténtalo en un momento.', true);
          });
        });
        card.appendChild(btnAv);
        card.appendChild(form);
      }

      return card;
    };

    /* ---- Chips de faceta + popovers ---- */
    let popoverAbierto = null;

    const cierraPopover = () => {
      if (!popoverAbierto) return;
      popoverAbierto.pop.hidden = true;
      popoverAbierto.btn.setAttribute('aria-expanded', 'false');
      popoverAbierto = null;
    };

    const filtrosActivos = () => Object.values(estado.sel).some(Boolean);

    const pintaChips = () => {
      const ph = PH();
      if (!ph) return;
      chipsBox.textContent = '';
      for (const f of ph.FACETAS) {
        const wrap = document.createElement('div');
        wrap.className = 'phs__chipwrap';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'phs__chip' + (estado.sel[f.key] ? ' is-active' : '');
        btn.setAttribute('aria-haspopup', 'true');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = estado.sel[f.key] ? `${f.label}: ${estado.sel[f.key]}` : f.label;
        const pop = document.createElement('div');
        pop.className = 'phs__pop';
        pop.hidden = true;
        const opciones = f.tipo === 'vendor'
          ? ph.vendors().map((v) => ({ v }))
          : f.opciones;
        for (const o of opciones) {
          const ob = document.createElement('button');
          ob.type = 'button';
          ob.className = 'phs__pop-opt' + (estado.sel[f.key] === o.v ? ' is-on' : '');
          ob.textContent = o.v;
          ob.addEventListener('click', (e) => {
            /* Sin esto el clic sube hasta el <dialog>, donde dialog.js ejecuta
               isClickedOutside() y cierra el buscador entero. El boton del chip ya
               lo hacia; las opciones no. */
            e.stopPropagation();
            estado.sel[f.key] = estado.sel[f.key] === o.v ? null : o.v;
            cierraPopover();
            pintaChips();
            refresca();
          });
          pop.appendChild(ob);
        }
        if (estado.sel[f.key]) {
          const quitar = document.createElement('button');
          quitar.type = 'button';
          quitar.className = 'phs__pop-opt phs__pop-opt--clear';
          quitar.textContent = 'Quitar filtro';
          quitar.addEventListener('click', (e) => {
            e.stopPropagation();
            estado.sel[f.key] = null;
            cierraPopover();
            pintaChips();
            refresca();
          });
          pop.appendChild(quitar);
        }
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const abierto = popoverAbierto && popoverAbierto.pop === pop;
          cierraPopover();
          if (!abierto) {
            pop.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
            popoverAbierto = { pop, btn };
          }
        });
        wrap.appendChild(btn);
        wrap.appendChild(pop);
        chipsBox.appendChild(wrap);
      }
    };

    dlg.addEventListener('click', (e) => {
      if (popoverAbierto && !e.target.closest('.phs__chipwrap')) cierraPopover();
    });
    /* Escape con popover abierto cierra el popover, no el buscador entero. */
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popoverAbierto) {
        e.stopPropagation();
        cierraPopover();
      }
    }, true);

    /* ---- Pintado de resultados ---- */
    const activa = (modo) => {
      vacio.hidden = modo !== 'vacio';
      resultados.hidden = modo === 'vacio';
    };

    const pinta = (anadir) => {
      if (!anadir) { grid.textContent = ''; estado.mostrados = 0; }
      const trozo = estado.items.slice(estado.mostrados, estado.mostrados + POR_TANDA);
      const frag = document.createDocumentFragment();
      trozo.forEach((p) => frag.appendChild(tarjeta(p)));
      grid.appendChild(frag);
      estado.mostrados += trozo.length;
      btnMas.hidden = estado.mostrados >= estado.items.length;
    };

    const prepararCero = (texto) => {
      modal.querySelector('[data-phs-zero-q]').textContent = texto;
      const q = modal.querySelector('[data-phs-zero-what]');
      if (q && !q.value) q.value = texto;
      /* Señal de demanda no cubierta aunque no rellenen el formulario. */
      try {
        (window.dataLayer = window.dataLayer || []).push({ event: 'search_zero_results', search_term: texto });
      } catch (_) {}
    };

    /* ---- Autocompletado ----
       Vive aparte del ciclo de resultados: se repinta en cada tecla sin esperar
       al debounce, porque una sugerencia que llega tarde ya no sirve de nada.
       La rejilla de abajo sigue con su propio ritmo. */
    let sugerencias = [];
    let sugSel = -1;

    const cierraSug = () => {
      if (!sugBox) return;
      sugerencias = [];
      sugSel = -1;
      sugBox.hidden = true;
      sugBox.textContent = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    };

    const marcaSug = () => {
      if (!sugBox) return;
      [...sugBox.children].forEach((li, i) => {
        const on = i === sugSel;
        li.classList.toggle('is-on', on);
        li.setAttribute('aria-selected', String(on));
      });
      if (sugSel >= 0) {
        input.setAttribute('aria-activedescendant', 'phs-sug-' + sugSel);
        const li = sugBox.children[sugSel];
        if (li && li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    };

    const aplicaSug = (i) => {
      const s = sugerencias[i];
      if (!s) return;
      input.value = s.texto;
      cierraSug();
      limpiar.hidden = false;
      refresca();
      input.focus();
    };

    /* Resalta en negrita el trozo que el cliente ya ha escrito. Se compara sobre
       el texto normalizado (sin tildes ni mayúsculas) pero se recorta sobre el
       ORIGINAL, para no romper "Balón" ni "Muñequeras" al pintarlo. */
    const pintaCoincidencia = (texto, q) => {
      const ph = PH();
      const frag = document.createDocumentFragment();
      const norm = ph ? ph.sinTildes(texto) : texto.toLowerCase();
      const i = norm.indexOf(q);
      if (!q || i === -1) {
        frag.appendChild(document.createTextNode(texto));
        return frag;
      }
      frag.appendChild(document.createTextNode(texto.slice(0, i)));
      const b = document.createElement('b');
      b.textContent = texto.slice(i, i + q.length);
      frag.appendChild(b);
      frag.appendChild(document.createTextNode(texto.slice(i + q.length)));
      return frag;
    };

    const pintaSug = () => {
      if (!sugBox || !PH() || !precargado) return;
      const bruto = input.value.trim();
      if (bruto.length < MINIMO) return cierraSug();

      sugerencias = PH().sugiere(bruto, MAX_SUGERENCIAS);
      if (!sugerencias.length) return cierraSug();

      const q = PH().sinTildes(bruto);
      sugBox.textContent = '';
      sugSel = -1;
      sugerencias.forEach((s, i) => {
        const li = document.createElement('li');
        li.className = 'phs__sug-item';
        li.id = 'phs-sug-' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        /* El texto va envuelto en su propio span. Suelto no vale: el <li> es
           flex, y el <b> del prefijo y el resto del título se convertirían en
           dos items de flex con el gap en medio ("Bull padel"). */
        const et = document.createElement('span');
        et.className = 'phs__sug-txt';
        et.appendChild(pintaCoincidencia(s.texto, q));
        li.appendChild(et);
        if (s.tipo) {
          const tag = document.createElement('span');
          tag.className = 'phs__sug-tipo';
          tag.textContent = s.tipo;
          li.appendChild(tag);
        }
        /* mousedown y no click: el click llega después del blur del input y
           para entonces la lista ya se ha cerrado. */
        li.addEventListener('mousedown', (e) => { e.preventDefault(); aplicaSug(i); });
        sugBox.appendChild(li);
      });
      sugBox.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    input.addEventListener('keydown', (e) => {
      if (sugBox && !sugBox.hidden) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          sugSel = (sugSel + 1) % sugerencias.length;
          return marcaSug();
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          sugSel = (sugSel <= 0 ? sugerencias.length : sugSel) - 1;
          return marcaSug();
        }
        if (e.key === 'Enter' && sugSel >= 0) {
          e.preventDefault();
          return aplicaSug(sugSel);
        }
        if (e.key === 'Escape') {
          /* Primer Escape cierra solo la lista; el buscador se queda abierto. */
          e.preventDefault();
          e.stopPropagation();
          return cierraSug();
        }
      }
    });

    input.addEventListener('blur', () => setTimeout(cierraSug, 120));

    const refresca = async () => {
      const bruto = input.value.trim();
      limpiar.hidden = bruto.length === 0;

      if (bruto.length < MINIMO && !filtrosActivos()) {
        activa('vacio');
        pie.hidden = true;
        return;
      }

      cargandoEl.hidden = false;
      activa('resultados');
      try {
        await PH().carga();
      } catch (_) {
        cuenta.textContent = 'No hemos podido cargar el catálogo. Inténtalo otra vez.';
        cargandoEl.hidden = true;
        return;
      }
      cargandoEl.hidden = true;
      if (input.value.trim() !== bruto) return; // siguió escribiendo

      const ph = PH();
      let items, etiqueta = null, parcial = false, correccion = null;
      if (bruto.length >= MINIMO) {
        const r = ph.busca(bruto);
        items = ph.filtra(r.items, estado.sel);
        etiqueta = r.etiqueta;
        parcial = !!r.parcial;
        correccion = r.correccion || null;
      } else {
        /* Solo filtros, sin texto: modo exploración sobre el catálogo entero. */
        items = ph.filtra(await ph.carga(), estado.sel);
      }

      estado.items = items;
      estado.bruto = bruto;
      pinta(false);

      const hay = items.length > 0;
      cero.hidden = hay;
      pie.hidden = !hay || bruto.length < MINIMO;
      const filtroTxt = filtrosActivos() ? ' (filtrado)' : '';
      /* Si se ha corregido la consulta hay que decirlo: si no, el cliente ve
         resultados de otra palabra y no entiende por qué. */
      const corrTxt = correccion ? ` Buscando «${correccion}».` : '';
      cuenta.textContent = !hay ? ''
        : bruto.length < MINIMO
          ? `${items.length} producto${items.length === 1 ? '' : 's'}${filtroTxt}`
          : parcial
            ? `No hay nada que encaje del todo con «${bruto}». Esto es lo más parecido (${items.length}).`
            : `${items.length} resultado${items.length === 1 ? '' : 's'}` +
              (etiqueta ? ` en ${etiqueta}` : '') + ` para «${bruto}»${filtroTxt}${corrTxt}`;
      if (!hay) prepararCero(bruto);
    };

    let temporizador;
    input.addEventListener('input', () => {
      /* Las sugerencias van SIN debounce: son una lectura del catálogo ya
         cargado, cuestan microsegundos, y esperar 220 ms a que aparezcan las
         hace inútiles. La rejilla de resultados sí espera. */
      pintaSug();
      clearTimeout(temporizador);
      temporizador = setTimeout(refresca, 220);
    });

    limpiar.addEventListener('click', () => {
      input.value = '';
      cierraSug();
      input.focus();
      refresca();
    });

    /* Enviar el formulario (Enter sin sugerencia elegida) no debe dejar la
       lista colgando por encima de los resultados. */
    form.addEventListener('submit', cierraSug);

    btnMas.addEventListener('click', () => pinta(true));

    modal.querySelector('[data-phs-viewall]').addEventListener('click', () => form.submit());

    /* El quiz vive fuera del top-layer del dialog: si no cerramos el buscador,
       el modal del quiz quedaría por debajo y no se vería. */
    modal.querySelector('[data-phs-quiz]').addEventListener('click', () => {
      if (document.querySelector('[data-phq]')) dlg.close();
    });

    /* ---- Precarga al abrir: catálogo + recomendados + chips ---- */
    const precarga = async () => {
      if (precargado || !PH()) return;
      precargado = true;
      PH().setRoot(ROOT);
      try {
        await PH().carga();
        pintaChips();
        pintaCompararCta();
        if (!recoPintado) {
          const reco = await PH().recomendados();
          recoGrid.textContent = '';
          const frag = document.createDocumentFragment();
          reco.forEach((p) => frag.appendChild(tarjeta(p)));
          recoGrid.appendChild(frag);
          recoPintado = true;
        }
      } catch (_) {
        recoGrid.textContent = '';
        precargado = false; // reintenta en la próxima apertura
      }
    };

    new MutationObserver(() => {
      if (dlg.open) precarga();
      else { cierraPopover(); cierraSug(); }
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    if (dlg.open) precarga();

    modal.addEventListener('close', () => { cierraPopover(); });

    /* ---- Captura de demanda: producto que no tenemos ---- */
    const btnEnviar = modal.querySelector('[data-phs-zero-send]');
    btnEnviar.addEventListener('click', async (e) => {
      e.preventDefault();
      const email = modal.querySelector('[data-phs-zero-email]').value.trim();
      const que = modal.querySelector('[data-phs-zero-what]').value.trim();
      const consent = modal.querySelector('[data-phs-zero-consent]').checked;
      const msg = modal.querySelector('[data-phs-zero-msg]');
      const aviso = (t, err) => { msg.textContent = t; msg.classList.toggle('is-error', !!err); msg.hidden = false; };

      if (!que) return aviso('Dinos qué producto buscabas.', true);
      if (!window.PHCapture) return aviso('No se pudo enviar. Recarga la página.', true);

      aviso('Enviando…');
      try {
        /* PHCapture centraliza la captación: bandeja + cliente con tag
           ph-producto-faltante (segmentable en el admin). */
        await window.PHCapture.enviar({
          email: email,
          consent: consent,
          tipo: 'producto-faltante',
          cuerpo: `Buscaba: ${que}\nTérmino tecleado: ${estado.bruto}`
        });
        aviso('Anotado. Te escribimos en cuanto lo tengamos.');
        btnEnviar.disabled = true;
      } catch (e) {
        if (e && e.message === 'email') return aviso('Escribe un email válido.', true);
        if (e && e.message === 'consent') return aviso('Marca la casilla para que podamos avisarte.', true);
        /* 'alta-*' = la petición SÍ llegó a la bandeja y solo ha fallado el alta de
           cliente, que sirve para segmentar. Pintarlo en rojo hacía que el cliente
           repitiera un envío que ya estaba hecho. */
        if (e && /^alta-/.test(e.message)) {
          console.error('[PHS] la petición entró, pero el alta de cliente no:', e.message);
          aviso('Anotado. Te escribimos en cuanto lo tengamos.');
          btnEnviar.disabled = true;
          return;
        }
        console.error('[PHS] no se ha podido enviar la petición:', (e && e.message) || e);
        aviso('No hemos podido enviarlo. Inténtalo en un momento.', true);
      }
    });
  })();
